import React,{useState} from "react";
import {
Modal,
Row,
Col,
Form,
Button
} from "react-bootstrap";
import {TiTimes} from "react-icons/ti";

export default function EmergencyContactModal({
show,
handleClose
}){

const [formData,setFormData]=useState({
name1:"",
relation1:"",
phone1:"",
phone2:"",
name3:"",
relation3:"",
phone3:"",
phone4:""
});

const handleChange=(e)=>{
setFormData({
...formData,
[e.target.name]:e.target.value
});
};

return(
<Modal
show={show}
onHide={handleClose}
size="lg"
centered
>

<Modal.Header
style={{
padding:"18px 20px",
borderBottom:"1px solid #e5e7eb",
position:"relative"
}}
>

<Modal.Title
style={{
fontWeight:"700",
fontSize:"22px",
color:"#1e2b4d"
}}
>
Emergency Contact Details
</Modal.Title>

<button
onClick={handleClose}
style={{
position:"absolute",
right:"18px",
top:"15px",
border:"none",
background:"#6b7280",
width:"28px",
height:"28px",
borderRadius:"50%",
color:"#fff"
}}
>
<TiTimes/>
</button>

</Modal.Header>


<Modal.Body style={{padding:"22px 20px"}}>

<h4
style={{
fontSize:"18px",
fontWeight:"700",
marginBottom:"22px"
}}
>
Secondary Contact Details
</h4>

<Row>

<Col md={6} xs={12}>
<Field
label="Name *"
name="name1"
value={formData.name1}
onChange={handleChange}
/>
</Col>

<Col md={6} xs={12}>
<Field
label="Relationship"
name="relation1"
value={formData.relation1}
onChange={handleChange}
/>
</Col>

<Col md={6} xs={12}>
<Field
label="Phone No 1 *"
name="phone1"
value={formData.phone1}
onChange={handleChange}
/>
</Col>

<Col md={6} xs={12}>
<Field
label="Phone No 2"
name="phone2"
value={formData.phone2}
onChange={handleChange}
/>
</Col>

</Row>

<hr style={{margin:"18px 0 22px"}}/>

<h4
style={{
fontSize:"18px",
fontWeight:"700",
marginBottom:"22px"
}}
>
Secondary Contact Details
</h4>

<Row>

<Col md={6} xs={12}>
<Field
label="Name *"
name="name3"
value={formData.name3}
onChange={handleChange}
/>
</Col>

<Col md={6} xs={12}>
<Field
label="Relationship"
name="relation3"
value={formData.relation3}
onChange={handleChange}
/>
</Col>

<Col md={6} xs={12}>
<Field
label="Phone No 1 *"
name="phone3"
value={formData.phone3}
onChange={handleChange}
/>
</Col>

<Col md={6} xs={12}>
<Field
label="Phone No 2"
name="phone4"
value={formData.phone4}
onChange={handleChange}
/>
</Col>

</Row>

</Modal.Body>


<Modal.Footer
style={{
borderTop:"1px solid #e5e7eb",
padding:"16px 20px"
}}
>

<Button
variant="light"
onClick={handleClose}
style={{
border:"1px solid #d1d5db"
}}
>
Cancel
</Button>

<Button
style={{
background:"#f97316",
border:"none"
}}
>
Save
</Button>

</Modal.Footer>

</Modal>
);
}

function Field({
label,
name,
value,
onChange
}){
return(
<Form.Group className="mb-4">
<Form.Label>{label}</Form.Label>

<Form.Control
name={name}
value={value}
onChange={onChange}
/>

</Form.Group>
);
}